import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useParams, useLocation, Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useTheme } from "../context/ThemeContext";
import { motion, AnimatePresence } from "framer-motion";
import { FiSun, FiMoon, FiShare2, FiArrowUp, FiArrowLeft, FiCheckCircle } from "react-icons/fi";
import Chatbot from "../components/Chatbot";
import ProfileModal from "../components/ProfileModal";
// Fallback image
const FALLBACK_IMAGE = "/zoomo-mascot.png";

// Updated dummyMenus (unchanged as per your request)
const dummyMenus = {
  1: {
    name: "I Love Pizza, Jourian",
    image: "/ilovepizzapic.jpg",
    dishes: [
      { id: "m1", name: "French Fries (Large)", category: "Snacks", price: 95, img: "https://source.unsplash.com/300x200/?fries" },
      { id: "m2", name: "Peri Peri Fries (Large)", category: "Snacks", price: 96, img: "https://source.unsplash.com/300x200/?peri fries" },
      { id: "m3", name: "Cheesy Peri Peri", category: "Snacks", price: 131, img: "https://source.unsplash.com/300x200/?cheesy fries" },
      { id: "m4", name: "Paneer Pops (16 pcs)", category: "Snacks", price: 251, img: "https://source.unsplash.com/300x200/?paneer" },
      { id: "m5", name: "Paneer Strips (6 pcs)", category: "Snacks", price: 155, img: "https://source.unsplash.com/300x200/?paneer strips" },
      { id: "m6", name: "Chicken Popcorn (16 pcs)", category: "Snacks", price: 275, img: "https://source.unsplash.com/300x200/?chicken popcorn" },
      { id: "m7", name: "Chicken Nuggets (12 pcs)", category: "Snacks", price: 275, img: "https://source.unsplash.com/300x200/?chicken nuggets" },
      { id: "m8", name: "Chicken Strips (6 pcs)", category: "Snacks", price: 155, img: "https://source.unsplash.com/300x200/?chicken strips" },
      { id: "m9", name: "Chicken Seekh Kebab", category: "Snacks", price: 143, img: "https://source.unsplash.com/300x200/?seekh kebab" },
      { id: "m10", name: "Mutton Seekh Kebab", category: "Snacks", price: 191, img: "https://source.unsplash.com/300x200/?mutton kebab" },
      { id: "m11", name: "Aloo Tikki Burger", category: "Burger", price: 47, img: "https://source.unsplash.com/300x200/?aloo tikki burger" },
      { id: "m12", name: "Veg Surprise Burger", category: "Burger", price: 83, img: "https://source.unsplash.com/300x200/?veg burger" },
      { id: "m13", name: "Chilli Lava Burger", category: "Burger", price: 83, img: "https://source.unsplash.com/300x200/?spicy burger" },
      { id: "m14", name: "Corn Burger", category: "Burger", price: 95, img: "https://source.unsplash.com/300x200/?corn burger" },
      { id: "m15", name: "Maha Veggie Burger", category: "Burger", price: 155, img: "https://source.unsplash.com/300x200/?veg burger" },
      { id: "m16", name: "Premium Paneer Burger", category: "Burger", price: 155, img: "https://source.unsplash.com/300x200/?paneer burger" },
      { id: "m17", name: "Fried Chicken Burger", category: "Burger", price: 95, img: "https://source.unsplash.com/300x200/?chicken burger" },
      { id: "m18", name: "Chicken Surprise Burger", category: "Burger", price: 107, img: "https://source.unsplash.com/300x200/?chicken burger" },
      { id: "m19", name: "Chicken Chilli Lava Burger", category: "Burger", price: 155, img: "https://source.unsplash.com/300x200/?spicy chicken burger" },
      { id: "m20", name: "Premium Fried Chicken Burger", category: "Burger", price: 167, img: "https://source.unsplash.com/300x200/?fried chicken burger" },
      { id: "m21", name: "Egg Burger", category: "Burger", price: 119, img: "https://source.unsplash.com/300x200/?egg burger" },
      { id: "m22", name: "Bombay Kachcha Sandwich", category: "Sandwich", price: 60, img: "https://source.unsplash.com/300x200/?kachcha sandwich" },
      { id: "m23", name: "Veg Grilled Sandwich", category: "Sandwich", price: 95, img: "https://source.unsplash.com/300x200/?grilled sandwich" },
      { id: "m24", name: "Cheese Corn Sandwich", category: "Sandwich", price: 95, img: "https://source.unsplash.com/300x200/?corn sandwich" },
      { id: "m25", name: "Paneer Tikka Sandwich", category: "Sandwich", price: 131, img: "https://source.unsplash.com/300x200/?paneer sandwich" },
      { id: "m26", name: "Italian Veg Sandwich", category: "Sandwich", price: 155, img: "https://source.unsplash.com/300x200/?italian sandwich" },
      { id: "m27", name: "Cheese Grilled Sandwich", category: "Sandwich", price: 155, img: "https://source.unsplash.com/300x200/?cheese sandwich" },
      { id: "m28", name: "Chicken Tikka Sandwich", category: "Sandwich", price: 167, img: "https://source.unsplash.com/300x200/?chicken sandwich" },
      { id: "m29", name: "Italian Chicken Sandwich", category: "Sandwich", price: 167, img: "https://source.unsplash.com/300x200/?chicken sandwich" },
      { id: "m30", name: "Crispy Fries Wrap", category: "Wraps", price: 119, img: "https://source.unsplash.com/300x200/?wrap" },
      { id: "m31", name: "Crispy Aloo Wrap", category: "Wraps", price: 119, img: "https://source.unsplash.com/300x200/?wrap" },
      { id: "m32", name: "Deluxe Veggie Wrap", category: "Wraps", price: 143, img: "https://source.unsplash.com/300x200/?wrap" },
      { id: "m33", name: "Crispy Paneer Wrap", category: "Wraps", price: 167, img: "https://source.unsplash.com/300x200/?paneer wrap" },
      { id: "m34", name: "Chicken Wrap", category: "Wraps", price: 167, img: "https://source.unsplash.com/300x200/?chicken wrap" },
      { id: "m35", name: "Chicken Kebab Wrap", category: "Wraps", price: 167, img: "https://source.unsplash.com/300x200/?kebab wrap" },
      { id: "m36", name: "Egg Wrap", category: "Wraps", price: 119, img: "https://source.unsplash.com/300x200/?egg wrap" },
      { id: "m37", name: "Veg Penne Arabiata", category: "Pasta", price: 131, img: "https://source.unsplash.com/300x200/?pasta" },
      { id: "m38", name: "Veg Mix Sauce Pasta", category: "Pasta", price: 155, img: "https://source.unsplash.com/300x200/?pasta" },
      { id: "m39", name: "Veg Creamy White Pasta", category: "Pasta", price: 155, img: "https://source.unsplash.com/300x200/?white pasta" },
      { id: "m40", name: "Cheese Pasta", category: "Pasta", price: 155, img: "https://source.unsplash.com/300x200/?cheesy pasta" },
      { id: "m41", name: "Chicken Penne Arabiata", category: "Pasta", price: 155, img: "https://source.unsplash.com/300x200/?chicken pasta" },
      { id: "m42", name: "Chicken Mix Sauce Pasta", category: "Pasta", price: 167, img: "https://source.unsplash.com/300x200/?chicken pasta" },
      { id: "m43", name: "Chicken Creamy White", category: "Pasta", price: 167, img: "https://source.unsplash.com/300x200/?white chicken pasta" },
      { id: "m44", name: "Chicken Cheesy Pasta", category: "Pasta", price: 191, img: "https://source.unsplash.com/300x200/?cheesy chicken pasta" },
      { id: "m101", name: "Margherita Pizza", category: "Pizza", price: 155, img: "https://source.unsplash.com/300x200/?margherita" },
      { id: "m102", name: "Cheese Corn Pizza", category: "Pizza", price: 215, img: "https://source.unsplash.com/300x200/?cheese corn" },
      { id: "m103", name: "Veggie Delight Pizza", category: "Pizza", price: 239, img: "https://source.unsplash.com/300x200/?veggie pizza" },
      { id: "m104", name: "Paneer Tikka Pizza", category: "Pizza", price: 299, img: "https://source.unsplash.com/300x200/?paneer pizza" },
      { id: "m105", name: "Teekha Paneer Pizza", category: "Pizza", price: 323, img: "https://source.unsplash.com/300x200/?spicy paneer" },
      { id: "m106", name: "Deluxe Veggie Pizza", category: "Pizza", price: 323, img: "https://source.unsplash.com/300x200/?deluxe veggie" },
      { id: "m107", name: "Mushroom Corn Delight", category: "Pizza", price: 323, img: "https://source.unsplash.com/300x200/?mushroom corn pizza" },
      { id: "m108", name: "Veg Extra Veganza", category: "Pizza", price: 371, img: "https://source.unsplash.com/300x200/?veganza" },
      { id: "m109", name: "Farmhouse Pizza", category: "Pizza", price: 407, img: "https://source.unsplash.com/300x200/?farmhouse pizza" },
      { id: "m110", name: "Cheese Brust Pizza", category: "Pizza", price: 359, img: "https://source.unsplash.com/300x200/?cheese burst" },
      { id: "m111", name: "Chicken Margherita Pizza", category: "Pizza", price: 179, img: "https://source.unsplash.com/300x200/?chicken margherita" },
      { id: "m112", name: "Chicken Delight Pizza", category: "Pizza", price: 299, img: "https://source.unsplash.com/300x200/?chicken pizza" },
      { id: "m113", name: "Chicken Tikka Pizza", category: "Pizza", price: 311, img: "https://source.unsplash.com/300x200/?chicken tikka pizza" },
      { id: "m114", name: "Teekha Chicken Pizza", category: "Pizza", price: 323, img: "https://source.unsplash.com/300x200/?spicy chicken pizza" },
      { id: "m115", name: "Deluxe Chicken Pizza", category: "Pizza", price: 347, img: "https://source.unsplash.com/300x200/?deluxe chicken pizza" },
      { id: "m116", name: "Chicken Seekh Pizza", category: "Pizza", price: 347, img: "https://source.unsplash.com/300x200/?seekh kebab pizza" },
      { id: "m117", name: "Chicken Extra Veganza", category: "Pizza", price: 371, img: "https://source.unsplash.com/300x200/?extra veg pizza" },
      { id: "m118", name: "Chicken Farmhouse Pizza", category: "Pizza", price: 407, img: "https://source.unsplash.com/300x200/?chicken farmhouse" },
      { id: "m119", name: "Chicken Cheese Brust Pizza", category: "Pizza", price: 383, img: "https://source.unsplash.com/300x200/?chicken cheese burst" },
      { id: "m120", name: "Mutton Seekh Kebab Pizza", category: "Pizza", price: 443, img: "https://source.unsplash.com/300x200/?mutton seekh pizza" },
      { id: "m121", name: "Veggie Delight Footlong", category: "Footlong", price: 191, img: "https://source.unsplash.com/300x200/?veggie footlong" },
      { id: "m122", name: "Paneer Tikka Footlong", category: "Footlong", price: 251, img: "https://source.unsplash.com/300x200/?paneer footlong" },
      { id: "m123", name: "Deluxe Veggie Footlong", category: "Footlong", price: 251, img: "https://source.unsplash.com/300x200/?deluxe veg footlong" },
      { id: "m124", name: "Veg Extravaganza Footlong", category: "Footlong", price: 263, img: "https://source.unsplash.com/300x200/?extravaganza footlong" },
      { id: "m125", name: "Veg Cheese Brust Footlong", category: "Footlong", price: 287, img: "https://source.unsplash.com/300x200/?cheese burst footlong" },
      { id: "m126", name: "Simply Chicken Footlong", category: "Footlong", price: 239, img: "https://source.unsplash.com/300x200/?chicken footlong" },
      { id: "m127", name: "Chicken Tikka Footlong", category: "Footlong", price: 287, img: "https://source.unsplash.com/300x200/?chicken tikka footlong" },
      { id: "m128", name: "Teekha Chicken Footlong", category: "Footlong", price: 287, img: "https://source.unsplash.com/300x200/?teekha footlong" },
      { id: "m129", name: "Deluxe Chicken Footlong", category: "Footlong", price: 287, img: "https://source.unsplash.com/300x200/?deluxe chicken footlong" },
      { id: "m130", name: "Chicken Extravaganza Footlong", category: "Footlong", price: 311, img: "https://source.unsplash.com/300x200/?chicken extravaganza" },
      { id: "m131", name: "Chicken Cheese Brust Footlong", category: "Footlong", price: 311, img: "https://source.unsplash.com/300x200/?cheesy chicken footlong" },
    ],
  },
  2: {
    name: "Sharma Fast Food",
    image: "/2023-10-18.webp",
    dishes: [
      {
        id: "d5",
        name: "Paneer Roll",
        category: "Street",
        price: 80 * 1.2,
        img: "https://source.unsplash.com/300x200/?paneer-roll",
        isPopular: true,
        customizations: {
          toppings: ["Extra Sauce", "Onions", "Lettuce"],
          spiceLevel: ["Mild", "Medium", "Spicy"],
        },
      },
      {
        id: "d6",
        name: "Chowmein",
        category: "Street",
        price: 100 * 1.2,
        img: "https://source.unsplash.com/300x200/?chowmein",
        customizations: {
          toppings: ["Soy Sauce", "Veggies", "Chicken"],
          spiceLevel: ["Mild", "Medium", "Spicy"],
        },
      },
      {
        id: "d7",
        name: "Tikki Burger",
        category: "Street",
        price: 70 * 1.2,
        img: "https://source.unsplash.com/300x200/?tikki-burger",
      },
      {
        id: "d8",
        name: "Sprite",
        category: "Drinks",
        price: 40 * 1.2,
        img: "https://source.unsplash.com/300x200/?sprite",
      },
    ],
  },
  3: {
    name: "Coffee Express",
    image: "/IMG_1210.JPG",
    dishes: [
      {
        id: "d9",
        name: "Cold Coffee",
        category: "Drinks",
        price: 120 * 1.2,
        img: "https://source.unsplash.com/300x200/?cold-coffee",
        isPopular: true,
      },
      {
        id: "d10",
        name: "Cappuccino",
        category: "Drinks",
        price: 110 * 1.2,
        img: "https://source.unsplash.com/300x200/?cappuccino",
      },
      {
        id: "d11",
        name: "Chocolate Muffin",
        category: "Dessert",
        price: 95 * 1.2,
        img: "https://source.unsplash.com/300x200/?muffin",
        isPopular: true,
      },
      {
        id: "d12",
        name: "Hazelnut Latte",
        category: "Drinks",
        price: 140 * 1.2,
        img: "https://source.unsplash.com/300x200/?latte",
      },
    ],
  },
  4: {
    name: "Taste of Punjab",
    image: "https://source.unsplash.com/300x200/?indian-food",
    dishes: [
      {
        id: "d13",
        name: "Butter Chicken",
        category: "Indian",
        price: 300 * 1.2,
        img: "https://source.unsplash.com/300x200/?butter-chicken",
        isPopular: true,
        customizations: {
          toppings: ["Extra Butter", "Coriander", "Cream"],
          spiceLevel: ["Mild", "Medium", "Spicy"],
        },
      },
      {
        id: "d14",
        name: "Naan",
        category: "Indian",
        price: 40 * 1.2,
        img: "https://source.unsplash.com/300x200/?naan",
        customizations: {
          toppings: ["Butter", "Garlic"],
        },
      },
      {
        id: "d15",
        name: "Paneer Tikka",
        category: "Indian",
        price: 250 * 1.2,
        img: "https://source.unsplash.com/300x200/?paneer-tikka",
        customizations: {
          toppings: ["Onions", "Bell Peppers"],
          spiceLevel: ["Mild", "Medium", "Spicy"],
        },
      },
      {
        id: "d16",
        name: "Gulab Jamun",
        category: "Dessert",
        price: 80 * 1.2,
        img: "https://source.unsplash.com/300x200/?gulab-jamun",
        isPopular: true,
      },
    ],
  },
  5: {
    name: "Moonlight Cafe",
    image: "/moonlight.jpg",
    dishes: [
      { id: "m1", name: "Mojito (Mint)", category: "Mocktail", price: 96, img: "/post_3966940.jpeg" },
      { id: "m2", name: "Watermelon", category: "Mocktail", price: 96, img: "/watermelon-mojito-3.jpg" },
      { id: "m3", name: "Blueberry", category: "Mocktail", price: 96, img: "/blueberry-mocktail-recipe.jpg" },
      { id: "m4", name: "Green Apple", category: "Mocktail", price: 96, img: "/GreenApplecooler_1.webp" },
      { id: "s1", name: "Strawberry Shake", category: "Shake", price: 84, img: "/Strawberry-milkshake-frappuccino-featured.jpg" },
      { id: "s2", name: "Butter Scotch Shake", category: "Shake", price: 84, img: "/butterscotch-milkshake-hero-recipe-735x735.webp" },
      { id: "s3", name: "Chocolate Shake", category: "Shake", price: 84, img: "/Brownie-Milkshake-Recipe-20-500x500.jpg" },
      { id: "s4", name: "Blueberry Shake", category: "Shake", price: 84, img: "/Blueberry-Smoothie-main.webp" },
      { id: "s5", name: "Oreo Shake", category: "Shake", price: 108, img: "/Oreo-Milkshake-recipe-card.jpg" },
      { id: "s6", name: "Kitkat Shake", category: "Shake", price: 108, img: "/Kit-Kat-Milkshake-14.jpg" },
      { id: "i1", name: "Regular Ice Tea", category: "Ice Tea", price: 30, img: "/109190-smooth-sweet-tea-DDMFS-4x3-9e849a386d414cb2b852099f02b6782d.jpg" },
      { id: "i2", name: "Large Ice Tea", category: "Ice Tea", price: 48, img: "/A-1027.jpg" },
      { id: "f1", name: "Regular Frappe", category: "Frappe", price: 48, img: "/fullsizeoutput_dc_2048x2048.webp" },
      { id: "f2", name: "Large Frappe", category: "Frappe", price: 108, img: "/SBX20220323_CaramelFrapp.jpg" },
      { id: "d1", name: "Coffee", category: "Drinks", price: 30, img: "/tips-to-recognize-good-quality-coffee-424970.webp" },
      { id: "d2", name: "Tea", category: "Drinks", price: 24, img: "/Masala-Chai-Tea-Recipe-Card.jpg" },
      { id: "p1", name: "Single Cheese Pizza", category: "Pizza", price: 120, img: "/cheese-pizza.webp" },
      { id: "p2", name: "Double Cheese Pizza", category: "Pizza", price: 144, img: "/Cheese-Pizza-2-1200.jpg" },
      { id: "p3", name: "Cheese & Corn Pizza", category: "Pizza", price: 144, img: "/zmb2tBOb.webp" },
      { id: "p4", name: "Farm Fresh (Veggies) Pizza", category: "Pizza", price: 144, img: "/Twg5CrcZcCgd5SKNhzX8tyxRJCWvxOKvxD4qRKhv.webp" },
      { id: "p5", name: "Tandoori Pizza", category: "Pizza", price: 144, img: "/chicken-tandoori-pizza.jpg" },
      { id: "p6", name: "Makhani Paneer Pizza", category: "Pizza", price: 144, img: "/paneer-pizza-recipe-1-2.jpg" },
      { id: "b1", name: "Aloo Tikki Burger", category: "Burger", price: 48, img: "/aloo-tikki-burger-recipe-9.jpg" },
      { id: "b2", name: "Juicy Corn Burger", category: "Burger", price: 60, img: "/eloteburgers6.jpg" },
      { id: "b3", name: "Cheesy Spicy Burger", category: "Burger", price: 72, img: "/62333823.cms.webp" },
      { id: "b4", name: "Paneer Burger", category: "Burger", price: 84, img: "/halloumi-burger-with-hot-honey-9.jpg" },
      { id: "sw1", name: "Grilled Sandwich", category: "Sandwich", price: 48, img: "/AvoBaconGrilledCheese_0011-scaled-e1682914545487.jpg" },
      { id: "sw2", name: "Cheesy Grilled Sandwich", category: "Sandwich", price: 72, img: "/Grilled-Chesese-and-spicy-Relish.jpg" },
      { id: "sw3", name: "Spicy Grilled Sandwich", category: "Sandwich", price: 84, img: "/Smoked-Tandoori-Paneer-Sandwich.jpg" },
      { id: "sw4", name: "Paneer Sandwich", category: "Sandwich", price: 108, img: "/Paneer-Sandwinch-FQ-9-2.jpg" },
      { id: "ps1", name: "Red Sauce Pasta", category: "Pasta", price: 120, img: "/creamy-pasta-sauce-recipe-featured.jpg" },
      { id: "ps2", name: "White Sauce Pasta", category: "Pasta", price: 120, img: "/White-Sauce-Paste-2-3.jpg" },
      { id: "ps3", name: "Tandoori Pasta", category: "Pasta", price: 120, img: "/tandoori-pasta-featured.jpg" },
      { id: "ps4", name: "Sweet and Spicy Pasta", category: "Pasta", price: 120, img: "/Spicy-Macaroni-Salad-feature-800x556.jpg" },
      { id: "w1", name: "Aloo Tikki Wrap", category: "Wraps", price: 96, img: "/maxresdefault.jpg" },
      { id: "w2", name: "Veg Cheese Wrap", category: "Wraps", price: 120, img: "/4526733-45129f82ed554ea1be3ac980d096a6f1.jpg" },
      { id: "w3", name: "Paneer Wrap", category: "Wraps", price: 132, img: "/image-646359-1717590397.jpeg" },
      { id: "fr1", name: "Fries", category: "Fries", price: 60, img: "/istockphoto-1443993866-612x612.jpg" },
      { id: "fr2", name: "Peri-Peri Fries", category: "Fries", price: 72, img: "/image-of-baked-crispy-peri-peri-fries-recipe-2.jpg" },
    ],
  },
};

// Toast Component
const Toast = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      className="fixed top-4 right-4 bg-[#00b86b] text-black px-4 py-2 rounded-2xl shadow-2xl z-[1000] animate-slide-in flex items-center gap-2"
    >
      <FiCheckCircle className="w-5 h-5" />
      {message}
      <style jsx>{`
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes fadeOut {
          from { opacity: 1; }
          to { opacity: 0; }
        }
        .animate-slide-in {
          animation: slideIn 0.3s ease-out forwards, fadeOut 0.3s ease-in 2.7s forwards;
        }
      `}</style>
    </div>
  );
};

const MenuPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { darkMode, toggleDarkMode } = useTheme();
  const { addToCart, cart, updateQuantity, toggleFavouriteDish, favourites } = useCart();

  const [filter, setFilter] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("default");
  const [selectedDish, setSelectedDish] = useState(null);
  const [customizations, setCustomizations] = useState({ toppings: [], spiceLevel: "", instructions: "" });
  const [quantity, setQuantity] = useState(1);
  const [schedule, setSchedule] = useState("");
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);

  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const mode = query.get("mode") || "delivery";
  const restaurant = dummyMenus[id];
  const cartTotalItems = useMemo(() => cart.reduce((sum, item) => sum + item.quantity, 0), [cart]);
  const categories = useMemo(
    () => (restaurant ? ["All", ...new Set(restaurant.dishes.map((d) => d.category))] : []),
    [restaurant]
  );
  const filteredDishes = useMemo(() => {
    if (!restaurant) return [];

    let result = restaurant.dishes.filter(
      (dish) =>
        dish.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        dish.category.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (filter !== "All") {
      result = result.filter((dish) => dish.category === filter);
    }

    if (sortOption === "price-low") {
      result.sort((a, b) => a.price - b.price);
    } else if (sortOption === "price-high") {
      result.sort((a, b) => b.price - a.price);
    } else if (sortOption === "name") {
      result.sort((a, b) => a.name.localeCompare(b.name));
    }

    return result;
  }, [searchTerm, filter, sortOption, restaurant]);

  // Load user avatar from localStorage
  const savedProfile = JSON.parse(localStorage.getItem("profile") || "{}");
  const userAvatar = savedProfile.avatar || "/zoomo-mascot.png";

  const handleModeChange = useCallback(
    (newMode) => {
      query.set("mode", newMode);
      navigate(`/menu/${id}?${query.toString()}`);
    },
    [navigate, query, id]
  );

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!restaurant) {
    return (
      <div className={`min-h-screen flex flex-col font-uber ${darkMode ? "bg-[#111] text-white" : "bg-[#fafafa] text-black"} text-center p-2 sm:p-6`}>
        <h1 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-red-600">Restaurant not found</h1>
      </div>
    );
  }

  const handleAddToCart = (dish, qty = 1) => {
    const dishObj = { id: dish.id, name: dish.name, price: dish.price, img: dish.img, restaurantId: id };
    addToCart(dishObj, qty, {}, null);
    setToastMessage(`${dish.name} added to cart!`);
  };

  const handleCustomize = (dish) => {
    setSelectedDish(dish);
    setCustomizations({ toppings: [], spiceLevel: "", instructions: "" });
    setQuantity(1);
    setSchedule("");
  };

  const handleConfirmAdd = () => {
    if (selectedDish) {
      const dishObj = { id: selectedDish.id, name: selectedDish.name, price: selectedDish.price, img: selectedDish.img, restaurantId: id };
      addToCart(dishObj, quantity, customizations, schedule || null);
      setToastMessage(`${selectedDish.name} added to cart with customizations!`);
      setSelectedDish(null);
      setCustomizations({ toppings: [], spiceLevel: "", instructions: "" });
      setQuantity(1);
      setSchedule("");
    }
  };

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const shareRestaurantLink = () => {
    const url = window.location.href;
    const whatsappUrl = `https://wa.me/?text=Check%20out%20the%20menu%20at%20${encodeURIComponent(restaurant.name)}%20on%20Zoomo%20Eats!%20${encodeURIComponent(url)}`;
    window.open(whatsappUrl, "_blank");
    setToastMessage(`Sharing ${restaurant.name} menu!`);
  };

  return (
    <div className={`min-h-screen flex flex-col font-uber ${darkMode ? "bg-[#111] text-white" : "bg-[#fafafa] text-black"} relative overflow-x-hidden transition-colors duration-300`}>
      <style jsx global>{`
        @import url('https://fonts.googleapis.com/css2?family=Uber+Move:wght@400;700&display=swap');
        .font-uber { font-family: 'Uber Move', sans-serif; }
        .animate-pulse-slow { animation: pulse 3s cubic-bezier(0.4, 0, 0.6, 1) infinite; }
        .animate-shake { animation: shake 0.5s; }
        @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-5px); } 75% { transform: translateX(5px); } }
        .custom-scrollbar::-webkit-scrollbar { width: 6px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: ${darkMode ? "#333" : "#e6f0ff"}; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #00b86b; border-radius: 10px; }
        .animate-slideIn { animation: slideIn 0.3s ease-out; }
        @keyframes slideIn { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        .animate-fadeInSection { animation: fadeIn 0.5s ease-out; }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        button:focus, input:focus { outline: none; box-shadow: 0 0 0 3px rgba(0, 184, 107, 0.3); }
        @media (max-width: 768px) {
          .grid-cols-3 { grid-template-columns: 1fr 1fr; }
          .px-4 { padding-left: 1rem; padding-right: 1rem; }
          .text-3xl { font-size: 1.75rem; }
          .text-2xl { font-size: 1.5rem; }
        }
        @media (max-width: 640px) {
          .grid-cols-2 { grid-template-columns: 1fr; }
          .px-4 { padding-left: 0.75rem; padding-right: 0.75rem; }
          .text-base { font-size: 0.875rem; }
          .text-sm { font-size: 0.75rem; }
        }
        @media (max-width: 400px) {
          .max-w-2xl { max-width: 100%; padding-left: 0.5rem; padding-right: 0.5rem; }
          .px-2 { padding-left: 0.5rem; padding-right: 0.5rem; }
          .text-2xl { font-size: 1.25rem; }
          .text-base { font-size: 0.75rem; }
        }
      `}</style>
      {toastMessage && <Toast message={toastMessage} onClose={() => setToastMessage(null)} />}
      <header
        className={`fixed top-0 left-0 w-full py-3 px-2 sm:px-6 flex justify-between items-center z-50 ${darkMode ? "bg-[#111]/95 shadow-[#00b86b]/20" : "bg-[#fafafa]/95 shadow-gray-200"} backdrop-blur-md shadow-sm transition-all duration-300 ${isScrolled ? "shadow-md" : "shadow-none"}`}
        role="banner"
      >
        <div className="flex items-center gap-2 sm:gap-3">
          <motion.img
            src="/zoomo-logo.png"
            alt="Zoomo Eats Logo"
            className="w-8 sm:w-10 h-8 sm:h-10"
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.3 }}
            onError={(e) => (e.target.src = FALLBACK_IMAGE)}
          />
          <h1 className="text-lg sm:text-2xl font-extrabold tracking-tight uppercase">
            ZOOMO <span className="text-[#00b86b]">EATS</span>
          </h1>
        </div>
        <nav className="flex items-center gap-2 sm:gap-4" role="navigation">
          <motion.button
            onClick={toggleDarkMode}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="p-2 rounded-full bg-[#00b86b] hover:bg-[#009e5c] text-black text-base sm:text-lg shadow-md transition-all duration-300"
            aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
          >
            {darkMode ? <FiSun className="w-5 sm:w-6 h-5 sm:h-6" /> : <FiMoon className="w-5 sm:w-6 h-5 sm:h-6" />}
          </motion.button>
          <motion.button
            onClick={() => setShowProfileModal(true)}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="relative group"
            aria-label="Open user profile modal"
          >
            <img
              src={userAvatar}
              alt="User Avatar"
              className="w-8 sm:w-10 h-8 sm:h-10 rounded-full object-cover border-2 border-[#00b86b] group-hover:scale-110 transition-transform duration-300"
              onError={(e) => (e.target.src = FALLBACK_IMAGE)}
            />
          </motion.button>
          <Link to="/cart" className="relative" aria-label="View cart">
            <svg className="w-6 sm:w-8 h-6 sm:h-8 text-[#00b86b]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            {cartTotalItems > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center animate-pulse">
                {cartTotalItems}
              </span>
            )}
          </Link>
        </nav>
      </header>

      <main className="pt-16 sm:pt-20 pb-8 sm:pb-12 px-2 sm:px-4 md:px-6 max-w-7xl mx-auto" role="main">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="relative h-40 sm:h-48 md:h-64 bg-cover bg-center animate-fadeInSection"
          style={{
            backgroundImage: `url(${restaurant.image || FALLBACK_IMAGE})`,
          }}
        >
          <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-center text-white">
            <h1 className="text-xl sm:text-2xl md:text-4xl font-extrabold mb-2">{restaurant.name}</h1>
            <p className="text-xs sm:text-sm capitalize">Mode: {mode}</p>
          </div>
        </motion.div>

        <section className="text-center py-4 px-2 sm:px-4 animate-fadeInSection">
          <p className={`text-xs sm:text-sm ${darkMode ? "text-gray-400" : "text-gray-600"} mb-3`}>
            Scan the QR code at the restaurant to select your dining mode.
          </p>
          <img
            src="/kbjkjhbkkbkbkb.png"
            alt="Restaurant QR Code"
            className="w-24 sm:w-32 h-24 sm:h-32 mx-auto rounded-lg"
            onError={(e) => (e.target.src = FALLBACK_IMAGE)}
          />
        </section>

        <section className="sticky top-14 sm:top-16 z-10 py-4 px-2 sm:px-4 bg-inherit animate-fadeInSection">
          <div className="flex flex-wrap justify-center gap-2 mb-3">
            {["delivery", "pickup", "dine-in"].map((opt) => (
              <motion.button
                key={opt}
                onClick={() => handleModeChange(opt)}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className={`px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-semibold transition-all duration-300 shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#00b86b] ${opt === mode ? "bg-[#00b86b] text-black" : darkMode ? "bg-[#333] text-white hover:bg-[#444]" : "bg-[#e6f0ff] text-black hover:bg-[#d3e3ff]"}`}
                aria-label={`Select ${opt} mode`}
              >
                {opt.charAt(0).toUpperCase() + opt.slice(1)}
              </motion.button>
            ))}
          </div>
          <div className="flex flex-col sm:flex-row justify-center gap-2">
            <div className="relative w-full sm:w-1/3">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search dishes..."
                className={`w-full px-4 py-2 sm:py-3 rounded-full border bg-[#e6f0ff] text-black placeholder:text-gray-500 border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#00b86b] text-xs sm:text-sm pl-8 sm:pl-10 shadow-sm transition-all duration-300 ${darkMode ? "bg-[#333] border-gray-700 text-white placeholder:text-gray-400" : ""}`}
                aria-label="Search dishes"
              />
              <svg
                className="absolute left-2 sm:left-3 top-2 sm:top-3 h-4 sm:h-5 w-4 sm:w-5 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <div className="flex flex-wrap justify-center gap-2">
              {categories.map((cat) => (
                <motion.button
                  key={cat}
                  onClick={() => setFilter(cat)}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className={`px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-semibold transition-all duration-300 shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#00b86b] ${filter === cat ? "bg-[#00b86b] text-black" : darkMode ? "bg-[#333] text-white hover:bg-[#444]" : "bg-[#e6f0ff] text-black hover:bg-[#d3e3ff]"}`}
                  aria-label={`Filter by ${cat}`}
                >
                  {cat}
                </motion.button>
              ))}
            </div>
            <select
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
              className={`px-4 py-2 sm:py-3 rounded-full border bg-[#e6f0ff] text-black placeholder:text-gray-500 border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#00b86b] text-xs sm:text-sm shadow-sm transition-all duration-300 ${darkMode ? "bg-[#333] border-gray-700 text-white" : ""}`}
              aria-label="Sort dishes"
            >
              <option value="default">Sort By: Default</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
              <option value="name">Name: A-Z</option>
            </select>
          </div>
        </section>
        <section className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 px-2 sm:px-4 animate-fadeInSection">
          {filteredDishes.map((dish) => {
            const cartItem = cart.find((item) => item.id === dish.id);
            const quantity = cartItem ? cartItem.quantity : 0;

            return (
              <motion.div
                key={dish.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className={`rounded-2xl shadow-2xl hover:shadow-[#00b86b]/20 transition-all duration-300 ${darkMode ? "bg-[#222] text-white" : "bg-[#fafafa] text-black"} relative`}
              >
                {dish.isPopular && (
                  <span className="absolute top-2 left-2 bg-yellow-500 text-black text-xs px-2 py-1 rounded-full shadow-sm">
                    Popular
                  </span>
                )}
                <img
                  src={dish.img || FALLBACK_IMAGE}
                  alt={dish.name}
                  className="w-full h-28 sm:h-32 md:h-36 object-cover rounded-t-2xl"
                  loading="lazy"
                  onError={(e) => (e.target.src = FALLBACK_IMAGE)}
                />
                <motion.button
                  onClick={() => {
                    toggleFavouriteDish(dish.id);
                    setToastMessage(
                      `${dish.name} ${favourites.dishes.includes(dish.id) ? "removed from" : "added to"} favorites!`
                    );
                  }}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  className="absolute top-4 right-4 text-xl sm:text-2xl focus:outline-none focus:ring-2 focus:ring-[#00b86b]"
                  aria-label={
                    favourites.dishes.includes(dish.id)
                      ? `Remove ${dish.name} from favorites`
                      : `Add ${dish.name} to favorites`
                  }
                >
                  <motion.span animate={{ scale: favourites.dishes.includes(dish.id) ? 1.2 : 1 }} transition={{ duration: 0.2 }}>
                    {favourites.dishes.includes(dish.id) ? "❤️" : "🤍"}
                  </motion.span>
                </motion.button>
                <div className="p-3">
                  <h2 className="text-sm sm:text-base font-semibold mb-1 truncate">{dish.name}</h2>
                  <p className={`text-xs ${darkMode ? "text-gray-400" : "text-gray-600"}`}>{dish.category}</p>
                  <p className="text-xs sm:text-sm font-semibold mt-1 text-[#00b86b]">₹{dish.price.toFixed(2)}</p>
                  <div className="flex justify-between items-center mt-3">
                    {quantity > 0 ? (
                      <div className="flex items-center gap-2">
                        <motion.button
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          onClick={() => {
                            updateQuantity(dish.id, -1);
                            setToastMessage(`Updated ${dish.name} quantity to ${quantity - 1}`);
                          }}
                          className={`px-2 sm:px-3 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-[#00b86b] ${darkMode ? "bg-[#333] text-white hover:bg-[#444]" : "bg-[#e6f0ff] text-black hover:bg-[#d3e3ff]"}`}
                          aria-label={`Decrease quantity of ${dish.name}`}
                        >
                          -
                        </motion.button>
                        <span className="text-xs sm:text-sm font-medium">{quantity}</span>
                        <motion.button
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          onClick={() => {
                            updateQuantity(dish.id, 1);
                            setToastMessage(`Updated ${dish.name} quantity to ${quantity + 1}`);
                          }}
                          className="bg-[#00b86b] hover:bg-[#009e5c] text-black px-2 sm:px-3 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-[#00b86b]"
                          aria-label={`Increase quantity of ${dish.name}`}
                        >
                          +
                        </motion.button>
                      </div>
                    ) : (
                      <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        onClick={() => handleAddToCart(dish)}
                        className="bg-[#00b86b] hover:bg-[#009e5c] text-black px-3 sm:px-4 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-semibold shadow-sm hover:shadow-md transition-all focus:outline-none focus:ring-2 focus:ring-[#00b86b]"
                        aria-label={`Add ${dish.name} to cart`}
                      >
                        Add to Cart
                      </motion.button>
                    )}
                    <motion.button
                      onClick={() => handleCustomize(dish)}
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      className="text-[#00b86b] hover:text-[#009e5c] text-xs font-semibold focus:outline-none focus:ring-2 focus:ring-[#00b86b]"
                      aria-label={`Customize ${dish.name}`}
                    >
                      Customize
                    </motion.button>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </section>
      </main>

      <AnimatePresence>
        {selectedDish && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 animate-slideIn"
            role="dialog"
            aria-modal="true"
            aria-labelledby="customize-dish-title"
          >
            <div
              className={`p-4 rounded-2xl shadow-2xl max-w-[90vw] sm:max-w-md w-full mx-2 max-h-[80vh] overflow-y-auto ${darkMode ? "bg-[#111] text-white" : "bg-[#fafafa] text-black"}`}
            >
              <h3 id="customize-dish-title" className="text-base sm:text-lg font-semibold mb-3">
                Customize {selectedDish.name}
              </h3>
              <div className="space-y-3 text-xs sm:text-sm">
                <div>
                  <label className="block text-xs sm:text-sm font-medium mb-1">Quantity</label>
                  <div className="flex items-center gap-2">
                    <motion.button
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      onClick={() => setQuantity((prev) => Math.max(1, prev - 1))}
                      className={`px-2 sm:px-3 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-[#00b86b] ${darkMode ? "bg-[#333] text-white hover:bg-[#444]" : "bg-[#e6f0ff] text-black hover:bg-[#d3e3ff]"}`}
                      aria-label="Decrease quantity"
                    >
                      -
                    </motion.button>
                    <span className="text-sm sm:text-base">{quantity}</span>
                    <motion.button
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      onClick={() => setQuantity((prev) => prev + 1)}
                      className="bg-[#00b86b] hover:bg-[#009e5c] text-black px-2 sm:px-3 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-[#00b86b]"
                      aria-label="Increase quantity"
                    >
                      +
                    </motion.button>
                  </div>
                </div>
                {selectedDish.customizations?.toppings && (
                  <div>
                    <label className="block text-xs sm:text-sm font-medium mb-1">Toppings</label>
                    <div className="flex flex-wrap gap-2">
                      {selectedDish.customizations.toppings.map((topping) => (
                        <label key={topping} className="flex items-center gap-1">
                          <input
                            type="checkbox"
                            checked={customizations.toppings.includes(topping)}
                            onChange={(e) => {
                              setCustomizations((prev) => ({
                                ...prev,
                                toppings: e.target.checked
                                  ? [...prev.toppings, topping]
                                  : prev.toppings.filter((t) => t !== topping),
                              }));
                            }}
                            className="h-4 w-4 text-[#00b86b] focus:ring-[#00b86b]"
                            aria-label={`Toggle ${topping} topping`}
                          />
                          <span className="text-xs sm:text-sm">{topping}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                )}
                {selectedDish.customizations?.spiceLevel && (
                  <div>
                    <label className="block text-xs sm:text-sm font-medium mb-1">Spice Level</label>
                    <select
                      value={customizations.spiceLevel}
                      onChange={(e) =>
                        setCustomizations((prev) => ({ ...prev, spiceLevel: e.target.value }))
                      }
                      className={`w-full px-3 py-2 rounded-full border bg-[#e6f0ff] text-black placeholder:text-gray-500 border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#00b86b] text-xs sm:text-sm ${darkMode ? "bg-[#333] border-gray-700 text-white" : ""}`}
                      aria-label="Select spice level"
                    >
                      <option value="">Select...</option>
                      {selectedDish.customizations.spiceLevel.map((level) => (
                        <option key={level} value={level}>
                          {level}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <div>
                  <label className="block text-xs sm:text-sm font-medium mb-1">Special Instructions</label>
                  <textarea
                    placeholder="E.g., No onions, extra cheese..."
                    value={customizations.instructions || ""}
                    onChange={(e) =>
                      setCustomizations((prev) => ({ ...prev, instructions: e.target.value }))
                    }
                    className={`w-full px-3 py-2 rounded-lg border bg-[#e6f0ff] text-black placeholder:text-gray-500 border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#00b86b] text-xs sm:text-sm ${darkMode ? "bg-[#333] border-gray-700 text-white placeholder:text-gray-400" : ""}`}
                    aria-label="Special instructions"
                  />
                </div>
                <div>
                  <label className="block text-xs sm:text-sm font-medium mb-1">Schedule Order (Optional)</label>
                  <input
                    type="datetime-local"
                    value={schedule}
                    onChange={(e) => setSchedule(e.target.value)}
                    min={new Date().toISOString().slice(0, 16)}
                    className={`w-full px-3 py-2 rounded-full border bg-[#e6f0ff] text-black placeholder:text-gray-500 border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#00b86b] text-xs sm:text-sm ${darkMode ? "bg-[#333] border-gray-700 text-white placeholder:text-gray-400" : ""}`}
                    aria-label="Schedule order"
                  />
                </div>
              </div>
              <div className="flex justify-end gap-2 mt-3">
                <motion.button
                  onClick={() => setSelectedDish(null)}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className={`text-xs sm:text-sm ${darkMode ? "text-gray-400 hover:text-gray-200" : "text-gray-500 hover:text-gray-700"} focus:outline-none focus:ring-2 focus:ring-gray-400`}
                  aria-label="Cancel customization"
                >
                  Cancel
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={handleConfirmAdd}
                  className="bg-[#00b86b] hover:bg-[#009e5c] text-black px-3 py-2 rounded-full text-xs sm:text-sm font-semibold shadow-sm hover:shadow-md transition-all focus:outline-none focus:ring-2 focus:ring-[#00b86b]"
                  aria-label="Confirm add to cart"
                >
                  Add to Cart
                </motion.button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Profile Modal */}
      <ProfileModal
        darkMode={darkMode}
        setToastMessage={setToastMessage}
        toggleFavouriteDish={toggleFavouriteDish}
        favourites={favourites}
        isOpen={showProfileModal}
        onClose={() => setShowProfileModal(false)}
      />

      {/* Chatbot Component */}
      <Chatbot darkMode={darkMode} setToastMessage={setToastMessage} />

      <div className="fixed bottom-4 right-4 z-[1000] flex flex-col gap-2">
        <Link to={`/restaurants?mode=${mode}`} aria-label="Go back to restaurants">
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            className="bg-[#00b86b] hover:bg-[#009e5c] text-black p-3 rounded-full shadow-2xl transition-all focus:outline-none focus:ring-2 focus:ring-[#00b86b]"
          >
            <FiArrowLeft className="w-5 h-5" />
          </motion.button>
        </Link>
        <Link to="/cart" aria-label="View cart">
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            className="bg-[#00b86b] hover:bg-[#009e5c] text-black p-3 rounded-full shadow-2xl relative transition-all focus:outline-none focus:ring-2 focus:ring-[#00b86b]"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            {cartTotalItems > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center animate-pulse">
                {cartTotalItems}
              </span>
            )}
          </motion.button>
        </Link>
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onClick={shareRestaurantLink}
          className="bg-[#00b86b] hover:bg-[#009e5c] text-black p-3 rounded-full shadow-2xl transition-all focus:outline-none focus:ring-2 focus:ring-[#00b86b]"
          aria-label="Share restaurant menu"
        >
          <FiShare2 className="w-5 h-5" />
        </motion.button>
        {showBackToTop && (
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={scrollToTop}
            className="bg-[#00b86b] hover:bg-[#009e5c] text-black p-3 rounded-full shadow-2xl transition-all focus:outline-none focus:ring-2 focus:ring-[#00b86b]"
            aria-label="Scroll to top"
          >
            <FiArrowUp className="w-5 h-5" />
          </motion.button>
        )}
      </div>
    </div>
  );
};

export default MenuPage;